import type { FC } from 'react';

import '@data/Simulations/pipeline/blocks/NoBaseBlock';

type NoBaseParametersProps = {
    blockId: string;
};

const NoBaseParameters: FC<NoBaseParametersProps> = () => null;

export default NoBaseParameters;
